/* AM Sports theme - vanilla JS, no dependencies */
(() => {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const T = window.theme || { routes: {} };
  const root = document.documentElement;

  /* ---------- Header height (for sticky offsets) ---------- */
  const header = $('[data-header]');
  const setHeaderH = () => { if (header) root.style.setProperty('--header-h', header.offsetHeight + 'px'); };
  setHeaderH();
  window.addEventListener('resize', setHeaderH);

  /* ---------- Drawers (mobile nav, cart, filters) ---------- */
  let lastTrigger = null;
  const openDrawer = (id, trigger) => {
    const d = $(`[data-drawer="${id}"]`);
    if (!d) return false;
    lastTrigger = trigger || document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    root.classList.add('no-scroll');
    const f = $('button, a, input', $('.drawer__panel', d));
    if (f) setTimeout(() => f.focus({ preventScroll: true }), 50);
    return true;
  };
  const closeDrawers = () => {
    $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    root.classList.remove('no-scroll');
    if (lastTrigger && lastTrigger.focus) lastTrigger.focus({ preventScroll: true });
  };
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-open-drawer]');
    if (open) {
      const id = open.dataset.openDrawer;
      if (id === 'cart' && !T.cartDrawer) return; // follow the link to /cart
      if (openDrawer(id, open)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close-drawer]')) closeDrawers();
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    closeDrawers();
    closeMenus();
    $$('[data-search-results]').forEach(b => { b.hidden = true; });
  });

  /* ---------- Desktop dropdown menu (keyboard and touch support) ---------- */
  const closeMenus = except => $$('.nav__item.is-open, .drop__item.is-open').forEach(li => {
    if (except && li.contains(except)) return;
    li.classList.remove('is-open');
    const t = $(':scope > .nav__toggle, :scope > .sub-toggle', li);
    if (t) t.setAttribute('aria-expanded', 'false');
  });
  $$('.nav__toggle, .sub-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const li = btn.parentElement;
      const willOpen = !li.classList.contains('is-open');
      closeMenus(li);
      li.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', String(willOpen));
    });
  });
  document.addEventListener('click', e => { if (!e.target.closest('.nav__item')) closeMenus(); });

  /* ---------- Cart ---------- */
  const updateCount = count => $$('[data-cart-count]').forEach(el => { el.textContent = count; el.hidden = count === 0; });
  async function refreshCart(open) {
    try {
      const [secRes, cartRes] = await Promise.all([
        fetch(`${T.routes.root}?sections=cart-drawer`),
        fetch(T.routes.cartJs, { headers: { Accept: 'application/json' } })
      ]);
      const sec = await secRes.json();
      const cart = await cartRes.json();
      const doc = new DOMParser().parseFromString(sec['cart-drawer'], 'text/html');
      const next = $('[data-cart-content]', doc);
      const cur = $('[data-cart-content]');
      if (next && cur) cur.replaceWith(next);
      updateCount(cart.item_count);
      if (open) openDrawer('cart');
    } catch (err) { window.location.href = T.routes.cartPage; }
  }
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-cart-change]');
    if (!btn) return;
    btn.disabled = true;
    try {
      await fetch(T.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(btn.dataset.line), quantity: Number(btn.dataset.qty) })
      });
    } catch (err) { /* fall through to refresh */ }
    refreshCart(false);
  });
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-ajax-add]');
    if (!form || !T.cartDrawer) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    const err = $('[data-form-error]', form);
    if (err) err.textContent = '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    try {
      const res = await fetch(T.routes.cartAdd, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add this item.');
      await refreshCart(true);
    } catch (ex) {
      if (err) err.textContent = ex.message; else alert(ex.message);
    } finally {
      if (btn) { btn.classList.remove('is-loading'); btn.disabled = btn.hasAttribute('data-soldout'); }
    }
  });

  /* ---------- Predictive search ---------- */
  $$('[data-search]').forEach(form => {
    const input = $('input[type="search"]', form);
    const box = $('[data-search-results]', form);
    if (!input || !box) return;
    let timer, ctrl;
    const close = () => { box.hidden = true; box.innerHTML = ''; };
    const run = async q => {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      try {
        const url = `${T.routes.predictive}?q=${encodeURIComponent(q)}&resources[type]=product,collection,query&resources[limit]=6&section_id=predictive-search`;
        const res = await fetch(url, { signal: ctrl.signal });
        if (!res.ok) throw new Error('search');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const out = $('#shopify-section-predictive-search', doc);
        if (out && out.innerHTML.trim()) { box.innerHTML = out.innerHTML; box.hidden = false; } else close();
      } catch (ex) { if (ex.name !== 'AbortError') close(); }
    };
    input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { close(); return; }
      timer = setTimeout(() => run(q), 220);
    });
    input.addEventListener('focus', () => { if (box.innerHTML.trim()) box.hidden = false; });
    document.addEventListener('click', e => { if (!form.contains(e.target)) box.hidden = true; });
  });

  /* ---------- Carousels (new arrivals, related products) ---------- */
  const initCarousels = (scope = document) => {
    $$('[data-carousel]', scope).forEach(c => {
      if (c.dataset.ready) return;
      c.dataset.ready = '1';
      const track = $('[data-track]', c), prev = $('[data-prev]', c), next = $('[data-next]', c);
      if (!track || !prev || !next) return;
      const step = () => {
        const first = track.firstElementChild;
        const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return first ? first.getBoundingClientRect().width + gap : 300;
      };
      const update = () => {
        prev.disabled = track.scrollLeft < 4;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      };
      prev.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
      next.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  };
  initCarousels();

  /* ---------- Collection filters ---------- */
  const ff = $('[data-filters-form]');
  if (ff) {
    let t;
    ff.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => ff.requestSubmit(), 350); });
    ff.addEventListener('submit', () => { $$('input[type="number"]', ff).forEach(i => { if (i.value === '') i.disabled = true; }); });
    $$('[data-sort]').forEach(s => s.addEventListener('change', () => ff.requestSubmit()));
    $$('[data-filter-more]', ff).forEach(b => b.addEventListener('click', () => {
      const list = b.previousElementSibling, open = list.classList.toggle('is-expanded');
      b.setAttribute('aria-expanded', String(open));
      b.textContent = open ? 'Show fewer' : `Show all ${list.children.length}`;
    }));
  }

  /* ---------- Product page ---------- */
  const pdp = $('[data-product-root]');
  if (pdp) {
    // gallery
    const slides = $$('.gallery__slide', pdp), thumbs = $$('[data-thumb]', pdp);
    const showMedia = id => {
      slides.forEach(s => s.classList.toggle('is-active', s.dataset.mediaId === String(id)));
      thumbs.forEach(b => b.classList.toggle('is-active', b.dataset.mediaId === String(id)));
    };
    thumbs.forEach(b => b.addEventListener('click', () => showMedia(b.dataset.mediaId)));

    // variants
    const dataEl = $('[data-variants]', pdp);
    if (dataEl) {
      const variants = JSON.parse(dataEl.textContent);
      const idInput = $('[data-variant-id]', pdp);
      const addBtn = $('[data-add-btn]', pdp);
      const stock = $('[data-stock]', pdp);
      const now = $('[data-price-now]', pdp), was = $('[data-price-was]', pdp), sku = $('[data-sku]', pdp);
      const onChange = () => {
        const chosen = $$('[data-option]:checked', pdp).map(i => i.value);
        const v = variants.find(x => x.options.every((o, i) => o === chosen[i]));
        if (!v) {
          addBtn.disabled = true; addBtn.textContent = 'Unavailable';
          stock.innerHTML = '<span class="stock__dot stock__dot--out"></span>Unavailable';
          return;
        }
        idInput.value = v.id;
        now.textContent = v.price;
        if (v.compare) { was.textContent = v.compare; was.hidden = false; } else { was.hidden = true; }
        if (sku) sku.textContent = v.sku || '';
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
        if (v.available) addBtn.removeAttribute('data-soldout'); else addBtn.setAttribute('data-soldout', '');
        stock.innerHTML = v.available ? '<span class="stock__dot stock__dot--in"></span>In stock' : '<span class="stock__dot stock__dot--out"></span>Sold out';
        if (v.media) showMedia(v.media);
        const url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url);
      };
      $$('[data-option]', pdp).forEach(i => i.addEventListener('change', onChange));
      const cur = variants.find(x => String(x.id) === idInput.value);
      if (cur && !cur.available) addBtn.setAttribute('data-soldout', '');
    }

    // lightbox (click a product photo to view it large)
    const lb = $('[data-lightbox]', pdp);
    if (lb) {
      const img = $('[data-lb-img]', lb), count = $('[data-lb-count]', lb);
      const prev = $('[data-lb-prev]', lb), next = $('[data-lb-next]', lb);
      let items = [], idx = 0, opener = null;
      const show = i => {
        idx = (i + items.length) % items.length;
        img.src = items[idx].large; img.alt = items[idx].alt;
        count.textContent = items.length > 1 ? `${idx + 1} / ${items.length}` : '';
        prev.hidden = next.hidden = items.length < 2;
        if (items.length > 1) { new Image().src = items[(idx + 1) % items.length].large; }
      };
      const openLb = btn => {
        items = $$('[data-zoom]', pdp).map(b => ({ id: b.dataset.mediaId, large: b.dataset.large, alt: b.dataset.alt }));
        opener = btn; lb.hidden = false; root.classList.add('no-scroll');
        show(Math.max(0, items.findIndex(x => x.id === btn.dataset.mediaId)));
        $('[data-lb-close]', lb).focus();
      };
      const closeLb = () => { if (lb.hidden) return; lb.hidden = true; root.classList.remove('no-scroll'); img.src = ''; if (opener) opener.focus({ preventScroll: true }); };
      $$('[data-zoom]', pdp).forEach(b => b.addEventListener('click', () => openLb(b)));
      $('[data-lb-close]', lb).addEventListener('click', closeLb);
      prev.addEventListener('click', () => show(idx - 1));
      next.addEventListener('click', () => show(idx + 1));
      lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
      document.addEventListener('keydown', e => {
        if (lb.hidden) return;
        if (e.key === 'Escape') closeLb();
        else if (e.key === 'ArrowLeft' && items.length > 1) show(idx - 1);
        else if (e.key === 'ArrowRight' && items.length > 1) show(idx + 1);
      });
      let sx = null;
      lb.addEventListener('touchstart', e => { sx = e.changedTouches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', e => {
        if (sx === null || items.length < 2) return;
        const dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 50) show(dx < 0 ? idx + 1 : idx - 1);
      }, { passive: true });
    }

    // quantity
    const q = $('[data-qty-input]', pdp);
    if (q) {
      $('[data-qty-minus]', pdp).addEventListener('click', () => { q.value = Math.max(1, (parseInt(q.value, 10) || 1) - 1); });
      $('[data-qty-plus]', pdp).addEventListener('click', () => { q.value = (parseInt(q.value, 10) || 1) + 1; });
    }
  }

  /* ---------- Product cards: slide to the second image on mouse hover or keyboard focus ---------- */
  const cardOf = el => (el && el.closest) ? el.closest('.card') : null;
  document.addEventListener('pointerover', e => {
    if (e.pointerType === 'touch') return;
    const c = cardOf(e.target); if (!c) return;
    const s = $('img[data-second]', c); if (s) s.loading = 'eager';
    c.classList.add('is-hover');
  });
  document.addEventListener('pointerout', e => {
    if (e.pointerType === 'touch') return;
    const c = cardOf(e.target);
    if (c && !c.contains(e.relatedTarget)) c.classList.remove('is-hover');
  });
  document.addEventListener('focusin', e => {
    const c = cardOf(e.target);
    if (c && e.target.matches('.card__link') && e.target.matches(':focus-visible')) c.classList.add('is-hover');
  });
  document.addEventListener('focusout', e => {
    const c = cardOf(e.target);
    if (c && !c.contains(e.relatedTarget)) c.classList.remove('is-hover');
  });

  /* ---------- Load the second card image shortly before a card scrolls into view ---------- */
  const preloadSecond = scope => {
    const imgs = $$('img[data-second]', scope);
    if (!imgs.length) return;
    if (!('IntersectionObserver' in window)) { imgs.forEach(i => { i.loading = 'eager'; }); return; }
    const io = new IntersectionObserver(entries => entries.forEach(en => {
      if (!en.isIntersecting) return;
      const img = $('img[data-second]', en.target);
      if (img) img.loading = 'eager';
      io.unobserve(en.target);
    }), { rootMargin: '300px' });
    $$('.card__media', scope).forEach(m => { if ($('img[data-second]', m)) io.observe(m); });
  };
  preloadSecond(document);

  /* ---------- Recommended products (loaded after first paint) ----------
     1) complementary = hand-picked or suggested pairings (Shopify Search & Discovery app)
     2) related       = Shopify's automatic suggestions, used only if no pairings are set */
  $$('[data-recs]').forEach(async el => {
    for (const intent of ['complementary', 'related']) {
      try {
        const res = await fetch(`${el.dataset.url}&intent=${intent}`);
        if (!res.ok) continue;
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const inner = $('[data-recs-content]', doc);
        if (inner) { el.innerHTML = inner.innerHTML; initCarousels(el); preloadSecond(el); break; }
      } catch (err) { /* recommendations are optional */ }
    }
  });

  /* ---------- Hero slideshow ---------- */
  const initHero = root => {
    if (!root || root.dataset.heroReady) return;
    const track = $('[data-hero-track]', root);
    if (!track) return;
    root.dataset.heroReady = '1';
    const total = track.children.length;
    const idx = el => Number(el.dataset.index);
    const dots = $$('[data-hero-dot]', root);
    const pauseBtn = $('[data-hero-pause]', root);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const dur = reduce ? 0 : 650;
    const interval = Math.max(3000, Number(root.dataset.interval) || 6000);
    let busy = false, timer = null, hovering = false, focused = false, offscreen = false, hold = false;
    let userPaused = root.dataset.autoplay !== 'true' || reduce;

    // keep slides in order starting from the visible one; hide the others from keyboard and screen readers
    const settle = () => {
      const first = idx(track.firstElementChild);
      Array.from(track.children)
        .sort((a, b) => ((idx(a) - first + total) % total) - ((idx(b) - first + total) % total))
        .forEach(el => track.appendChild(el));
      Array.from(track.children).forEach((el, i) => {
        if (i === 0) { el.removeAttribute('inert'); el.removeAttribute('aria-hidden'); }
        else { el.setAttribute('inert', ''); el.setAttribute('aria-hidden', 'true'); }
      });
      dots.forEach((d, i) => { d.classList.toggle('is-active', i === first); d.setAttribute('aria-current', i === first ? 'true' : 'false'); });
    };
    settle();
    if (total < 2) return;

    const ease = `transform ${dur}ms cubic-bezier(.65,0,.35,1)`;
    const run = dir => {
      if (busy) return; busy = true;
      if (dir > 0) {
        track.style.transition = dur ? ease : 'none';
        track.style.transform = 'translateX(-100%)';
        setTimeout(() => {
          track.style.transition = 'none';
          track.appendChild(track.firstElementChild);
          track.style.transform = 'translateX(0)';
          settle(); void track.offsetWidth; busy = false;
        }, dur + 30);
      } else {
        track.style.transition = 'none';
        track.insertBefore(track.lastElementChild, track.firstElementChild);
        track.style.transform = 'translateX(-100%)';
        void track.offsetWidth;
        track.style.transition = dur ? ease : 'none';
        track.style.transform = 'translateX(0)';
        setTimeout(() => { settle(); busy = false; }, dur + 30);
      }
    };
    const goTo = i => {
      if (busy || i === idx(track.firstElementChild)) return;
      const target = Array.from(track.children).find(el => idx(el) === i);
      if (!target) return;
      track.insertBefore(target, track.children[1]);   // slide straight to it
      run(1);
    };

    const canPlay = () => !userPaused && !hold && !hovering && !focused && !offscreen && !document.hidden && root.isConnected;
    const schedule = () => { clearTimeout(timer); timer = null; if (canPlay()) timer = setTimeout(tick, interval); };
    // each slide stays still for the full interval: the countdown starts once the slide has finished moving
    const tick = () => {
      timer = null; if (!root.isConnected) return;
      if (canPlay()) { run(1); timer = setTimeout(tick, dur + 40 + interval); } else { schedule(); }
    };

    const prev = $('[data-hero-prev]', root), next = $('[data-hero-next]', root);
    if (prev) prev.addEventListener('click', () => { run(-1); schedule(); });
    if (next) next.addEventListener('click', () => { run(1); schedule(); });
    dots.forEach((d, i) => d.addEventListener('click', () => { goTo(i); schedule(); }));
    if (pauseBtn) pauseBtn.addEventListener('click', () => {
      userPaused = !userPaused;
      pauseBtn.setAttribute('aria-pressed', String(userPaused));
      pauseBtn.setAttribute('aria-label', userPaused ? 'Play slideshow' : 'Pause slideshow');
      track.setAttribute('aria-live', userPaused ? 'polite' : 'off');
      schedule();
    });
    if (reduce && pauseBtn) { pauseBtn.setAttribute('aria-pressed', 'true'); pauseBtn.setAttribute('aria-label', 'Play slideshow'); }
    track.setAttribute('aria-live', userPaused ? 'polite' : 'off');

    root.addEventListener('mouseenter', () => { hovering = true; schedule(); });
    root.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    // only keyboard focus holds the slideshow; clicking a button with the mouse must not leave it stuck
    root.addEventListener('focusin', e => { focused = !!(e.target.matches && e.target.matches(':focus-visible')); schedule(); });
    root.addEventListener('focusout', e => { if (!root.contains(e.relatedTarget)) { focused = false; schedule(); } });
    document.addEventListener('visibilitychange', schedule);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(en => { offscreen = !en[0].isIntersecting; schedule(); }, { threshold: 0.2 }).observe(root);
    }

    // swipe on touch screens
    let sx = null, sy = null;
    track.addEventListener('touchstart', e => { sx = e.changedTouches[0].clientX; sy = e.changedTouches[0].clientY; }, { passive: true });
    track.addEventListener('touchend', e => {
      if (sx === null) return;
      const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy; sx = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) { run(dx < 0 ? 1 : -1); schedule(); }
    }, { passive: true });

    root._hero = { goTo, hold: on => { hold = on; schedule(); } };
    schedule();
  };
  $$('[data-hero]').forEach(initHero);
  window.addEventListener('load', () => $$('.hero__slide img[loading="lazy"]').forEach(i => { i.loading = 'eager'; }));

  // Shopify theme editor: keep the slideshow working while settings change, and show the slide being edited
  document.addEventListener('shopify:section:load', e => $$('[data-hero]', e.target).forEach(initHero));
  document.addEventListener('shopify:block:select', e => {
    const root = e.target.closest && e.target.closest('[data-hero]');
    if (root && root._hero) { root._hero.hold(true); root._hero.goTo(Number(e.target.dataset.index)); }
  });
  document.addEventListener('shopify:block:deselect', e => {
    const root = e.target.closest && e.target.closest('[data-hero]');
    if (root && root._hero) root._hero.hold(false);
  });

})();
